import { useTranslation } from 'react-i18next';

type Environment = 'development' | null;

function getEnvironment(): Environment {
  const explicitEnvironment = (import.meta.env.VITE_APP_ENV || '').toLowerCase();
  if (explicitEnvironment === 'development' || explicitEnvironment === 'dev') return 'development';
  return null;
}

export function EnvironmentBadge() {
  const { t } = useTranslation();
  const environment = getEnvironment();
  if (!environment) return null;

  return (
    <div className="environment-badge pointer-events-none fixed end-0 top-0 z-40 overflow-hidden" aria-hidden="true">
      <div className="environment-badge__ribbon absolute rotate-45 bg-danger py-1 text-center text-xs font-bold uppercase tracking-wider text-danger-foreground shadow-lg ring-1 ring-danger-foreground/40">
        {t(`common.environment.${environment}`)}
      </div>
    </div>
  );
}
